import DataStatus from './DataStatus'

export default DataStatus